import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ControlledNumberInput, I18N_NAMESPACES, Label } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
const PDP_QUANTITY_SELECTOR = 'pdp-quantity';
export const ProductQuantityContainer = ({ quantity, setQuantity, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    return (_jsxs(_Fragment, { children: [_jsx(Label, { emphasized: true, htmlFor: PDP_QUANTITY_SELECTOR, children: t('pdp.quantity') }), _jsx(Box, { mobile: { spacing: { marginTop: 1 } }, children: _jsx(ControlledNumberInput, { id: PDP_QUANTITY_SELECTOR, minQuantity: 1, quantity: quantity, onUpdate: setQuantity }) })] }));
};
